import { FC } from 'react';
import { useTranslation } from '@nextgen-web-framework/all';
import { ProductQuantityComponentPropsTypes } from './types/propsTypes';
import styles from './ProductQuantityComponent.module.scss';
import { ProductQuantityType } from './types/enums';

const ProductQuantityComponent: FC<ProductQuantityComponentPropsTypes> = ({
  productQuantity,
  productQuantityType,
}: ProductQuantityComponentPropsTypes): JSX.Element => {
  const t = useTranslation();

  const getProductQtyClassname = () => {
    switch (productQuantityType) {
      case ProductQuantityType.CART_CARD_VARIANT:
        return 'product-qty-card-variant';
      case ProductQuantityType.FREE_PRODUCT_CARD:
        return 'product-qty-free-product';
      case ProductQuantityType.AllPRODUCTCARD:
        return 'product-qty-all-product';
      case ProductQuantityType.APOINT_PRODUCT_CARD:
        return 'product-qty-apoint-product';
      default:
        return 'product-qty';
    }
  };

  return (
    <>
      <div className={styles[getProductQtyClassname()]}>
        {`${t('product.productQuantityComponent.qty')} ${productQuantity}`}
      </div>
    </>
  );
};

export default ProductQuantityComponent;
export type { ProductQuantityComponentPropsTypes };
export { ProductQuantityType };
